const NS = 'KnowledgeCheckBlock';
const CLS = 'knowledgeCheckBlock';
const CLS_BTN_CORRECT = `${CLS}-commands-button--correct`;
const CLS_NAV_ACTIVE = `${CLS}-nav-item--active`;

import { scrollIntoView } from 'scroll-js';

export class KnowledgeCheckBlock {
	constructor(element) {
		this.element = element;
		this.$element = $(element);

		this.$blocks = this.$element.find('.Form__Element.FormChoice').children('[class*="Block"]');
		this.$navs;
		this.$activeBlock;
		this.$tracker = $('[data-pg][data-tracker="true"]');
		this.trackingId = this.$element.data('trackingId');
		this.textSubmit = this.$element.data('textSubmit') || 'Submit';
		this.textTryAgain = this.$element.data('textTryAgain') || 'Try Again';
		this.textSelectAnswer = this.$element.data('textSelectAnswer') || 'Please select an answer.';
		this.textCorrect = this.$element.data('textCorrect') || 'Correct';
		this.textQuizComplete = this.$element.data("textQuizComplete") || "Quiz Complete, Continue";
		this.textCorrectProceed = this.$element.data('textCorrectProceed') || 'Correct, proceed to next question';

		if(this.hasTrackingId()) {
			if(!this.hasTracker()) {
				console.error(`${NS}::Error`, 'Please ensure that the "[data-pg][data-tracker="true"]" element exists.');
				return;
			}
		}

		this.initNavItems();
		this.initBlockClasses();
		this.initCommandsMarkup();
		this.initInitialNavItem();
		this.initSubmitButtonEvent();
		this.initResetButtonEvent();

		this.scrollDuration = 750;
        this.scrollEasing = 'ease-in-out';
        this.$tplScroller = $('.tpl-scroller');
	}

	initNavItems() {
		let getBlockListMarkup = () => {
			return `<div class="${CLS}-nav">
				${(() => {
					let blockListTemplate = '';
					this.$blocks.each((index, _element) => {
						blockListTemplate += `<a id="${CLS}-nav-item--${index}" class="${CLS}-nav-item ${CLS}-nav-item--${index}" href="javascript:void(0)" data-index="${index}" aria-selected="false"></a>`;
					});
					return blockListTemplate;
				})()}
			</div>`;
		};

		this.$blocks.each((index, element) => {
			$(element).find('[class*="-inner-content"]').children('.container').find('h2[class*="Block-title"]').before(getBlockListMarkup());
		});

		this.$navs = this.$element.find(`.${CLS}-nav`);
		this.$navItems = this.$navs.find(`.${CLS}-nav-item`);
		this.$navItems.on('click', (event) => {
			let navItemIndex = $(event.currentTarget).data('index');
			this.updateActiveBlock(navItemIndex);
		});

		// Hide navigation if there is only a single Block element
		if(this.$blocks.length <= 1) {
			this.$navs.hide();
		}
	}

	initBlockClasses() {
		this.$blocks.each((index, element) => {
			$(element).addClass(`${CLS}-question`);
		});
	}

	initCommandsMarkup() {
		let commandsElementMarkup = () => {
			return `<div class="${CLS}-commands">
				<div class="row">
					<div class="col-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
						<div class="error-messages">
							${this.textSelectAnswer}
						</div>
					</div>
					<div class="col-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-lg-6 offset-lg-3">
						<div class="${CLS}-commands-buttons">
							<button type="button" class="btn btn-block btn-secondary ${CLS}-commands-button ${CLS}-commands-button--reset mb-1">
								${this.textTryAgain}
							</button>
							<button type="button" class="btn btn-block btn-secondary ${CLS}-commands-button ${CLS}-commands-button--submit mb-1">
								${this.textSubmit}
							</button>
						</div>
					</div>
				</div>
			</div>`;
		};

		this.$blocks.each((index, element) => {
			$(element).find('[class*="-inner-content"]').children('.container').append(commandsElementMarkup());
		});
	}

	initInitialNavItem() {
		this.updateActiveBlock(0);
	}

	initSubmitButtonEvent() {
		this.$buttonSubmit = this.$blocks.find(`.${CLS}-commands-button--submit`);

		this.$buttonSubmit.on('click', (event) => {
			let $clickedButton = $(event.currentTarget);
			let $block = $clickedButton.parents(`.Form__Element.FormChoice`);
			if($clickedButton.hasClass(CLS_BTN_CORRECT) && $block.next('.Form__Element.FormChoice').length > 0) {
				this.handleNext($clickedButton);
			}
			else {
				this.handleSubmit($clickedButton);
			}
		});
	}

	handleSubmit($clickedButton) {
		let $block = $clickedButton.parents(`.${CLS}-question`);

		let correctAnswersCSV = $block.data('answers'); // CSV formatted answers
		let correctAnswers = [];

		if(correctAnswersCSV) {
			correctAnswersCSV = correctAnswersCSV.toString();
			correctAnswers = correctAnswersCSV.split(',');

			correctAnswers.forEach((value, index) => {
				correctAnswers[index] = value.trim();
			});
		}

		let $answerBlocks = $block.find('[class*="AnswerBlock"]');

		if(correctAnswers && correctAnswers.length > 0) {
			let $selectedMultiChoiceAnswerBlocks = $block.find('[class*="AnswerBlock--selected"]');

			if($selectedMultiChoiceAnswerBlocks && $selectedMultiChoiceAnswerBlocks.length > 0) {
				$clickedButton.parents(`.${CLS}-commands`).find('.error-messages').removeClass('is-active'); // Hides the validation error

				let selectedCorrectAnswersCount = 0;
				let blockIndex = this.$blocks.index($clickedButton.parents(`.${CLS}-question`));

				// Iterate through multiChoiceAnswerBlocks to mark as correct/incorrect.
				$answerBlocks.each((index, element) => {
					let isSelected;

					if($(element).hasClass('multiChoiceAnswerBlock')) {
						isSelected = $(element).hasClass('multiChoiceAnswerBlock--selected');
					}
					else if($(element).hasClass('imageSelectAnswerBlock')) {
						isSelected = $(element).hasClass('imageSelectAnswerBlock--selected');
					}
					else {
						// skip the span or label element
						return;
					}

					let value = $(element).find('input').val();

					let isCorrectAnswer = _.find(correctAnswers, (correctAnswer) => {
						return correctAnswer === value;
					});

					if(isSelected) {
						if(isCorrectAnswer) {
							selectedCorrectAnswersCount++; // Count the amount of selected correct answers
							if($(element).hasClass('multiChoiceAnswerBlock')) {
								$(element).addClass('multiChoiceAnswerBlock--correct');
							}
							else if($(element).hasClass('imageSelectAnswerBlock')) {
								$(element).addClass('imageSelectAnswerBlock--correct');
							}
						}
						else {
							if($(element).hasClass('multiChoiceAnswerBlock')) {
								$(element).addClass('multiChoiceAnswerBlock--incorrect');
							}
							else if($(element).hasClass('imageSelectAnswerBlock')) {
								$(element).addClass('imageSelectAnswerBlock--incorrect');
							}
						}
					}

					$(element).find('input').prop('disabled', true);
				});

				// Mark block navigation item as correct/incorrect
				if(selectedCorrectAnswersCount === correctAnswers.length) {
					this.$navs.find(`.${CLS}-nav-item--${blockIndex}`).addClass(`${CLS}-nav-item--correct`);
					$block.attr('data-answers-correct', true);
					$clickedButton.addClass(CLS_BTN_CORRECT);
					$clickedButton.text(this.$blocks.length <= 1 ? this.textCorrect : this.textCorrectProceed);
				}
				else {
					this.$navs.find(`.${CLS}-nav-item--${blockIndex}`).addClass(`${CLS}-nav-item--incorrect`);
					$block.attr('data-answers-correct', false);

					// Hides the submit button
					$clickedButton.css({ display: 'none' });
					$clickedButton.siblings(`.${CLS}-commands-button--reset`).css({ display: 'block' });
				}

				// if it's the last block and already answered all question
				if(this.$blocks.filter('[data-answers-correct="true"]').length === this.$blocks.length) {
					let $lastBlock = this.$blocks.eq(this.$blocks.length - 1);
					$lastBlock.find(`.${CLS}-commands-button--submit`).text(this.textQuizComplete);
						
					this.$buttonSubmit = this.$blocks.find(`.knowledgeCheckBlock-commands-button--submit`);
					this.$buttonSubmit.on('click', (event) => {
						let section = $($(".sectionNavigatorWidget-item--knowledgeCheck").next().find(".sectionNavigatorWidget-link").attr("data-block"))[0];
						scrollIntoView(section, this.$tplScroller[0], { duration: this.scrollDuration, easing: this.scrollEasing }).then();
					});	
				}

				// Tracking code
				this.updateTrackingCompleteStatus();
			}
			else {
				$clickedButton.parents(`.${CLS}-commands`).find('.error-messages').addClass('is-active'); // Displays the validation error
			}
		}
		else {
			console.error(`${NS}::Error`, 'Please ensure there is an answer supplied for this block.');
		}
	}

	handleNext($clickedButton) {
		let $block = $clickedButton.parents(`.${CLS}-question`);
		let blockIndex = this.$blocks.index($block);

		if(blockIndex < this.$blocks.length) {
			let nextBlockIndex = blockIndex + 1;
			this.updateActiveBlock(nextBlockIndex);
			this.$navs.find(`.${CLS}-nav-item--${nextBlockIndex}`);
		}
	}

	initResetButtonEvent() {
		this.$buttonReset = this.$blocks.find(`.${CLS}-commands-button--reset`);
		this.$buttonReset.on('click', (event) => {
			let $clickedButton = $(event.currentTarget);
			let $block = $clickedButton.parents(`.${CLS}-question`);
			let blockIndex = this.$blocks.index($block);

			let $answerBlocks = $block.find('[class*="AnswerBlock"]');

			$answerBlocks.each((index, element) => {
				let $input = $(element).find('input');
				if(!($(element).hasClass('multiChoiceAnswerBlock') || $(element).hasClass('imageSelectAnswerBlock'))) {
					return;
				}

				$input.prop('disabled', false);
			});

			this.$navs.each((index, element) => {
				$(element).find(`.${CLS}-nav-item`).eq(blockIndex).removeClass(`${CLS}-nav-item--correct ${CLS}-nav-item--incorrect`);
			});
			$clickedButton.css({ display: 'none' });
			$clickedButton.siblings(`.${CLS}-commands-button--submit`).css({ display: 'block' });
			$block.attr('data-answers-correct', '');
			if(_.isBoolean(this.$element.data('trackingComplete')) && this.$element.data('trackingComplete')) {
				this.updateTrackingIncompleteStatus();
			}
		});
	}

	hasTrackingId() {
		return !_.isNil(this.trackingId) && this.trackingId !== '';
	}

	hasTracker() {
		return this.$tracker && this.$tracker.length > 0;
	}

	updateTrackingCompleteStatus() {
		if(this.hasTrackingId() && this.hasTracker()) {
			if(this.$blocks.filter('[data-answers-correct="true"]').length === this.$blocks.length) {
				this.$tracker.trigger('tracking.complete', { $element: this.$element, trackingId: this.trackingId } );
				this.$element.attr('data-tracking-complete', true);
			}
		}
	}

	updateTrackingIncompleteStatus() {
		if(this.hasTrackingId() && this.hasTracker()) {
			if(this.$blocks.filter('[data-answers-correct="true"]').length < this.$blocks.length) {
				this.$tracker.trigger('tracking.incomplete', { $element: this.$element, trackingId: this.trackingId } );
				this.$element.attr('data-tracking-complete', false);
			}
		}
	}

	updateActiveBlock(index) {
		if(this.$activeBlock) {
			this.$activeBlock.parent().attr('data-active', false);
		}
		this.$activeBlock = this.$blocks.eq(index);

		if(this.$activeBlock) {
			this.$activeBlock.parent().attr('data-active', true);
			this.$activeBlock.find(`.${CLS}-nav-item:eq(${index})`).addClass(CLS_NAV_ACTIVE);
		}
	}
}
